"use client";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Select, Table, Image } from "antd";
import { Modal } from "antd";
import React from "react";
import Cookies from "js-cookie";
import { formatCurrencyWithSign } from "@/lib/utils";
import InfoIcon from "@/assets/Icons/infoIcon.svg";
import creaditCards from "@/assets/images/creditcards.png";
import islamicImage from "@/assets/images/Islamic/islamic-logo.png";
import "@/components/CheckoutPage/Modules/BNPLModal/BNPLModal.scss";

const InstallmentsModal = ({
  isOpen,
  onClose,
  title,
  price,
  installments,        // commission_installment_plans (BAFL)
  allBankPlans,        // all_bank_installment_plans (object with .plans array, or raw array)
  selectedInstallment, // currently selected BAFL plan string
  selectedAllBankPlan, // currently selected All Bank plan string
  onSelectBAFL,        // (value: string) => void
  onSelectAllBank,     // (value: string) => void
  handleBuy,           // () => void — triggers checkout
}) => {

  // Debug logs
  // console.log("allbankplan>>>>>>>>",allBankPlans)
  // console.log("selectedInstallment>>>>>>>>",selectedInstallment)
  // console.log("selectedAllBankPlan>>>>>>>>",selectedAllBankPlan)

  const { Option } = Select;
  const selectedCurrency = Cookies.get("fashionCurrencyName") || "PKR";

  // ── BAFL table data ──
  const dataBAFL = installments?.processing_fees?.map((feeInfo, index) => {
    const monthsMatch = feeInfo.plan.match(/(\d+)\s*Months?/i);
    const months = monthsMatch ? parseInt(monthsMatch[1]) : null;
    const correspondingPlan = installments?.plans?.find(
      (plan) => plan.months === months,
    ); return {
      key: index,
      plan: feeInfo.plan,
      fee: feeInfo.fees,
      installment_price: feeInfo.installment_price || "N/A",
      interest_rate: correspondingPlan?.interest_rate ?? null,
    };
  });

  const columnsBAFL = [
    {
      title: "Installment Plans",
      dataIndex: "plan",
      key: "plan",
      align: "center",
      className: "table-header",
      render: (text, record) => (
        <span>
          {text}
          {record.interest_rate === 0 ? " (0% Markup)" : " (Markup)"}
        </span>
      ),
      onCell: (record) => ({
        style: {
          backgroundColor: record.interest_rate === 0 ? "#D62314" : "white",
          color: record.interest_rate === 0 ? "white" : "black",
        },
      }),
    },
    {
      title: "Processing Fees + FED (One Time)",
      dataIndex: "fee",
      key: "fee",
      align: "center",
      className: "table-header",
      render: (text) => <span style={{ color: "red", fontWeight: "500" }}>{text}</span>,
    },
    {
      title: "Installment Price",
      dataIndex: "installment_price",
      key: "installment_price",
      align: "center",
      className: "table-header",
      render: (text) => <span style={{ fontWeight: "500" }}>{selectedCurrency} {text}</span>,
    },
  ];

  const BAFLCardPlanOptions = installments?.plans?.map((plan, index) => (
    <Option key={`bafl-plan-${index}`} value={plan.installment_plan}>
      {plan.installment_plan}
    </Option>
  ));

  // ── All Bank Plans ──
  // allBankPlans can be an object { plans, processing_fees, plan_details } or a raw array


  // Build table data same way as BNPLModal
  // const dataABCC = allBankPlans?.processing_fees
  // ?.map((feeInfo, index) => {
  //   const monthsMatch = feeInfo.plan?.match(/(\d+)\s*Months?/i);
  //   const months = monthsMatch ? parseInt(monthsMatch[1]) : null;
  //   const matchingDetail = allBankPlans?.plan_details?.find((d) => {
  //     const detailMonths = d.tenure?.match(/(\d+)\s*Months?/i);
  //     return detailMonths ? parseInt(detailMonths[1]) === months : false;
  //   });
  //   return {
  //     key: index,
  //     plan: feeInfo.plan,
  //     fee: feeInfo.fees,
  //     installment_price: matchingDetail?.installment_fee || null,
  //     product_price: matchingDetail?.product_price || null,
  //   };
  // })


  const dataABCC = allBankPlans?.processing_fees?.map((feeInfo, index) => {
    const monthsMatch = feeInfo.plan?.match(/(\d+)\s*Months?/i);
    const months = monthsMatch ? parseInt(monthsMatch[1]) : null;

    const matchingDetail = allBankPlans?.plan_details?.find((d) => {
      const detailMonths = d.tenure?.match(/(\d+)\s*Months?/i);
      return detailMonths ? parseInt(detailMonths[1]) === months : false;
    });

    console.log("matchingDetail>?>>>>>>>", matchingDetail)

    return {
      key: index,
      plan: feeInfo.plan,
      fee: feeInfo.fees,
      installment_price: matchingDetail?.installment_fee || null,
      product_price: matchingDetail?.product_price || null,
    };
  });

  console.log("dataABCC>>>>>>>>>>", dataABCC)

  const columnsABCC = [
    {
      title: "Installment Plans",
      dataIndex: "plan",
      key: "plan",
      align: "center",
      className: "table-header",
    },
    {
      title: "Product Price",
      dataIndex: "product_price",
      key: "product_price",
      align: "center",
      className: "table-header",
      render: (text) => (
        <span style={{ fontWeight: "500" }}>
          {text ? `${selectedCurrency} ${Number(text).toLocaleString()}` : "—"}
        </span>
      ),
    },
    {
      title: "Monthly Installment",
      dataIndex: "installment_price",
      key: "installment_price",
      align: "center",
      className: "table-header",
      render: (text) => (
        <span style={{ fontWeight: "500" }}>
          {text ? `${selectedCurrency} ${text}/Month` : "—"}
        </span>
      ),
    },
  ];

  // const AllBankPlanOptions = allBankPlans?.processing_fees
  // .map((plan, index) => {
  //   const label = typeof plan === "object" ? (plan.plan || plan.installment_plan) : plan;
  //   const value = typeof plan === "object" ? (plan.plan || plan.installment_plan) : plan;
  //   return (
  //     <Option key={`allbank-plan-${index}`} value={value}>
  //       {label}
  //     </Option>
  //   );
  // });

  const AllBankPlanOptions = allBankPlans?.plans?.map((plan, index) => {
    if (typeof plan === "object") {
      return (
        <Option key={`allbank-plan-${index}`} value={plan.value}>
          {plan.label}
        </Option>
      );
    }
    return (
      <Option key={`allbank-plan-${index}`} value={plan}>
        {plan}
      </Option>
    );
  });

  const hasBaflPlans = BAFLCardPlanOptions?.length > 0;
  const hasAllBankPlans = AllBankPlanOptions?.length > 0;
  const canCheckout = !!selectedInstallment || !!selectedAllBankPlan;

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      closeIcon={<CloseOutlined style={{ color: "black" }} />}
      styles={{
        body: {
          padding: "20px 10px",
          opacity: 1,
          overflowY: "auto",
          maxHeight: "85vh",
        },
      }}
      width={640}
      className="BAFL-card-modal"
    >
      <h2 style={{ textAlign: "left", fontWeight: "500", fontSize: "24px", color: "#333333" }}>
        {title?.split(" | ")[0]}
      </h2>
      <h2 style={{ textAlign: "left", fontWeight: "500", fontSize: "20px", color: "#333333" }}>
        Product Price: {formatCurrencyWithSign(price, selectedCurrency)}
      </h2>

      {/* ── BAFL Section ── */}
      {hasBaflPlans && (
        <>
          <div className="creditCards">
            <img src={creaditCards.src} alt="creditCards" width={60} height={60} />
            <h2 style={{ textAlign: "left", fontWeight: "bold", lineHeight: 1 }}>
              Bank Alfalah Credit Card
            </h2>
          </div>

          <Select
            value={selectedInstallment || "Select Installment Plan"}
            onChange={onSelectBAFL}
            style={{ width: "100%", marginBottom: "10px", borderRadius: "5px" }}
          >
            {BAFLCardPlanOptions}
          </Select>

          {dataBAFL.length > 0 && (
            <Table
              columns={columnsBAFL}
              dataSource={dataBAFL}
              pagination={false}
              bordered
              className="bnpl-installment-table"
              style={{ marginBottom: "20px", border: "1px solid rgb(235, 235, 235)", borderRadius: "5px" }}
            />
          )}

          {selectedInstallment && (
            <div style={{ display: "flex" }} className="bnpl-helper-container">
              <span style={{ marginTop: "2px" }} className="marginRight5">
                <Image height="auto" width={20} src={InfoIcon.src} preview={false} alt="info-icon" />
              </span>
              <p className="bnpl-helper-text font12Bold" style={{ marginTop: "2px" }}>
                Your instalment-based plan will be booked within 3 working days and you will see a
                charge of {selectedInstallment?.split("/")[0]} appear in your next bill. Your card
                limit of {formatCurrencyWithSign(price, selectedCurrency)} will be reserved against
                this purchase.
              </p>
            </div>
          )}

          <div className="bnpl-helper-container">
            <span className="marginRight5">
              <Image height="auto" width={20} src={InfoIcon.src} preview={false} alt="info-icon" />
            </span>
            <p className="bnpl-helper-text font12Bold" style={{ marginTop: "2px" }}>
              Credit Cards within 3 months of issuance and without available limit are ineligible to avail Installments.
            </p>
          </div>
        </>
      )}

      {/* ── All Bank Plans Section ── */}
      {hasAllBankPlans && (
        <>
          <div className="all-banks-credicts-heading">
            <img src={islamicImage.src} width={60} height={60} alt="Islamic Logo" className="islamic-logo-image" />
            <h2 style={{ textAlign: "left", fontWeight: "bold", lineHeight: 1 }}>All Bank&apos;s Credit Cards</h2>
          </div>

          <Select
            value={selectedAllBankPlan || "Select Installment Plan"}
            onChange={onSelectAllBank}
            style={{ width: "100%", marginBottom: "10px", borderRadius: "5px" }}
          >
            {AllBankPlanOptions}
          </Select>

          {dataABCC?.length > 0 && (
            <Table
              columns={columnsABCC}
              dataSource={dataABCC}
              pagination={false}
              bordered
              className="bnpl-installment-table"
              style={{ marginBottom: "10px", border: "1px solid rgb(235, 235, 235)", borderRadius: "5px" }}
            />
          )}

          <div style={{ display: "flex", alignItems: "flex-start", gap: "6px", marginBottom: "10px" }}>
            <Image height="auto" width={20} src={InfoIcon.src} preview={false} alt="info-icon" />
            <p className="bnpl-helper-text font12Bold" style={{ marginTop: "2px" }}>
              All Bank&apos;s Credit Cards on 0% processing fees on all tenures
              <br />
              <span className="font12">Maximum Limit of up to 750K based on eligibility criteria</span>
            </p>
          </div>
        </>
      )}

      <Button
        onClick={handleBuy}
        size="large"
        disabled={!canCheckout}
        style={{
          backgroundColor: canCheckout ? "#333333" : "#ccc",
          fontSize: "14px",
          marginBottom: "10px",
          color: "white",
          padding: "20px",
          width: "100%",
          borderRadius: "0",
          alignItems: "center",
          border: "none",
        }}
      >
        Checkout
      </Button>
    </Modal>
  );
};

export default InstallmentsModal;
